export const visitPhaseStyles = {
    upcoming: {
        label: 'Starts in',
        color: '#1b5e20',
        bg: '#c8e6c9',
        barBg: 'rgba(129, 199, 132, 0.28)',
        barColor: '#c8e6c9',
    },
    ongoing: {
        label: 'In session',
        color: '#f57f17',
        bg: '#fff59d',
        barBg: 'rgba(255, 235, 59, 0.28)',
        barColor: '#fff59d',
    },
    ending: {
        label: 'Ending soon',
        color: '#e65100',
        bg: '#ffcc80',
        barBg: 'rgba(255, 152, 0, 0.4)',
        barColor: '#ffcc80',
    },
    over: {
        label: 'Slot ended',
        color: '#b71c1c',
        bg: '#ef9a9a',
        barBg: 'rgba(244, 67, 54, 0.35)',
        barColor: '#ef9a9a',
    },
};

export function formatSessionClock(ms) {
    const total = Math.max(0, Math.floor(Number(ms) / 1000));
    const hours = Math.floor(total / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const seconds = total % 60;
    const mm = String(minutes).padStart(2, '0');
    const ss = String(seconds).padStart(2, '0');
    if (hours > 0) {
        return `${hours}:${mm}:${ss}`;
    }
    return `${mm}:${ss}`;
}

export function liveVisitSession(session) {
    if (!session) {
        return null;
    }
    const now = Date.now();
    const start = new Date(session.startsAt || session.scheduledAt).getTime();
    const end = new Date(session.endsAt || start + 15 * 60 * 1000).getTime();
    if (Number.isNaN(start) || Number.isNaN(end)) {
        return null;
    }
    let phase = 'upcoming';
    let ms = start - now;
    if (now >= start && now < end - 3 * 60 * 1000) {
        phase = 'ongoing';
        ms = now - start;
    } else if (now >= start && now < end) {
        phase = 'ending';
        ms = end - now;
    } else if (now >= end) {
        phase = 'over';
        ms = now - end;
    }
    const style = visitPhaseStyles[phase];
    return {
        ...session,
        phase,
        ms,
        clock: formatSessionClock(ms),
        label: phase === 'ongoing' ? 'Elapsed' : style.label,
        style,
    };
}
